import { graphql } from "msw";
import { MINUS_ONE } from "CONST/constants";

let idCount = 1;
/* eslint-disable sort-keys */
const notifications = [
    {
        id: `${idCount}`,
        user: "1",
        title: "Launchday 1.4.0 update email sent",
        body: "Sent to all 1,851 subscribers over a 24 hour period",
        status: "info",
        actions: [],
        read: false,
        timestamp: 1607904530221,
        tag: "comment",
    },
    {
        id: `${++idCount}`,
        user: "1",
        title: "New project \"Goodkit\" created",
        body: "Looks like there might be a new theme soon.",
        status: "info",
        link: "#",
        actions: [],
        read: true,
        timestamp: 1606904510221,
        tag: "content",
    },
    {
        id: `${++idCount}`,
        user: "1",
        title: "Dashkit 1.5.0 was deployed.",
        body: "A successful to deploy to production was executed.",
        status: "info",
        actions: [],
        read: true,
        timestamp: 1607804510000,
        tag: "info",
    },
    {
        id: `${++idCount}`,
        user: "1",
        title: "\"Update Dependencies\" branch was created.",
        body: "This branch was created off of the \"master\" branch.",
        status: "info",
        link: "#",
        actions: [],
        read: false,
        timestamp: 1607918918126,
        tag: "lock",
    },
];
/* eslint-enable sort-keys */

export const handlers = [
    graphql.query("notifications", (req, res, ctx) =>
        res(ctx.data({ notificationsUpdated: notifications }))
    ),
    graphql.query("notification", (req, res, ctx) => {
        const { notificationID } = req.variables.payload;
        return res(ctx.data({ notification: notifications.find(({ id }) => id === notificationID) }));
    }),
    graphql.mutation("addNotification", (req, res, ctx) => {
        const { notification: newNotification } = req.variables.payload;
        const id = idCount++;
        const notification = {
            id,
            user: "1",
            ...newNotification
        };
        notifications.push(notification);
        return res(ctx.data({ addNotification: notification }));
    }),
    graphql.mutation("UpdateManyNotificationsRead", (req, res, ctx) => {
        const { payload: notificationsToUpdate, context: { user } } = req.variables;
        notificationsToUpdate.forEach(({ id, read }) => {
            const updateIndex = notifications.findIndex(({ id: nid }) => id === nid);
            if (updateIndex !== MINUS_ONE){
                notifications[updateIndex].read = read;
            }
        });

        const userNotifications = notifications.filter(({ user: uid }) => uid === user);
        return res(ctx.data({ updateManyNotificationsRead: userNotifications }));
    }),
];
